import { css } from "@compiled/react";
import { useIntl } from "react-intl";

import UFOSegment from "@atlaskit/react-ufo/segment";

import { useLocalizedHref } from "@/libraries/web-framework";
import { Row } from "@/libraries/wpl/foundations/src";
import { HalpLogoBrand } from "@/libraries/wpl/foundations/src/logos/halp-logo-brand";
import { JiraServiceManagementLogoBrand } from "@/libraries/wpl/foundations/src/logos/jiraservicemanagement-logo-brand";
import { OpsgenieLogoBrand } from "@/libraries/wpl/foundations/src/logos/opsgenie-logo-brand";
import { StatuspageLogoBrand } from "@/libraries/wpl/foundations/src/logos/statuspage-logo-brand";

import { TryPageCard } from "../../components/try-page-card";
import { TryPageHeader } from "../../components/try-page-header";
import { messages } from "../messages";

/* Cards */
const JsmCard = () => {
    const intl = useIntl();

    const localizedLink = useLocalizedHref(
        "/try/cloud/signup?bundle=jira-service-management"
    );
    const localizedBodyText = intl.formatMessage({
        id: "TryPageTemplate.supportAndFix.jsmCard.bodyText",
        defaultMessage:
            "Collaborate at high-velocity, respond to business changes and deliver great customer and employee service experiences fast."
    });

    const localizedCtaText = intl.formatMessage(messages.tryCloud);

    return (
        <TryPageCard
            logo={<JiraServiceManagementLogoBrand />}
            link={localizedLink}
            bodyText={localizedBodyText}
            ctaText={localizedCtaText}
        />
    );
};

const OpsGenieCard = () => {
    const intl = useIntl();

    const localizedLink = useLocalizedHref("/software/opsgenie/try");
    const localizedBodyText = intl.formatMessage({
        id: "TryPageTemplate.supportAndFix.opsGenieCard.bodyText",
        defaultMessage:
            "Notify the right people at the right time with powerful incident alerts and on-call schedules."
    });

    const localizedCtaText = intl.formatMessage({
        id: "TryPageTemplate.tryCloud",
        defaultMessage: "Try cloud"
    });

    return (
        <TryPageCard
            logo={<OpsgenieLogoBrand />}
            link={localizedLink}
            bodyText={localizedBodyText}
            ctaText={localizedCtaText}
        />
    );
};

const StatusCard = () => {
    const intl = useIntl();

    const localizedLink = useLocalizedHref(
        "/try/cloud/signup?bundle=statuspage"
    );
    const localizedBodyText = intl.formatMessage({
        id: "TryPageTemplate.supportAndFix.statusCard.bodyText",
        defaultMessage:
            "Incidents happen. Keep your users informed with fewer support emails during downtime."
    });

    const localizedCtaText = intl.formatMessage({
        id: "TryPageTemplate.tryCloud",
        defaultMessage: "Try cloud"
    });

    return (
        <TryPageCard
            logo={<StatuspageLogoBrand />}
            link={localizedLink}
            bodyText={localizedBodyText}
            ctaText={localizedCtaText}
        />
    );
};

const HalpCard = () => {
    const intl = useIntl();

    const localizedLink = useLocalizedHref(
        "/software/halp?utm_medium=atl_try&utm_source=atl_try&utm_campaign=atl_try"
    );
    const localizedBodyText = intl.formatMessage({
        id: "TryPageTemplate.supportAndFix.halpCard.bodyText",
        defaultMessage:
            "Capture, track, and report on requests with a lightweight help desk built for Slack and Microsoft Teams users."
    });

    const localizedCtaText = intl.formatMessage({
        id: "TryPageTemplate.tryCloud",
        defaultMessage: "Try cloud"
    });

    return (
        <TryPageCard
            logo={<HalpLogoBrand />}
            link={localizedLink}
            bodyText={localizedBodyText}
            ctaText={localizedCtaText}
        />
    );
};

const sectionStyles = css({
    padding: "32px 0",
    position: "relative",
    verticalAlign: "baseline",
    marginInlineEnd: "auto",
    marginInlineStart: "auto",
    minWidth: "100%"
});

const SupportAndFixSection = () => {
    const intl = useIntl();
    const headerText = intl.formatMessage({
        id: "TryPageTemplate.supportAndFix.headerText",
        defaultMessage: "Support & fix"
    });

    return (
        <UFOSegment name={"support-and-fix"}>
            <div css={sectionStyles}>
                <Row>
                    <TryPageHeader
                        dividerColor="#ff8b00"
                        headerText={headerText}
                    />
                </Row>
                <Row layout="6-6">
                    <JsmCard />
                    <OpsGenieCard />
                </Row>
                <div />
                <Row layout="6-6">
                    <StatusCard />
                    <HalpCard />
                </Row>
            </div>
        </UFOSegment>
    );
};

export default SupportAndFixSection;
